<template>
  <router-link to="/contacts" class="text-[--link-color] hover:text-[--link-hover-color]">
    {{ $t("common.links.contact_administrator") }}
  </router-link>
</template>
